module.exports = __webpack_public_path__ + "static/img/office-hong-kong.e35cc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/office-hong-kong.png
// module id = Sfl/
// module chunks = 1